var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(!_vm.userConnectedWalletAddress)?_c('ConnectButton'):(!_vm.loading)?_c('SharedButton',{attrs:{"disabled":_vm.disabled},on:{"click":_vm.execTx}},[_vm._t("default")],2):(_vm.loading)?_c('p',[_c('ImageVue',{attrs:{"src":'loading.svg',"size":'45px'}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }